import axios from 'axios';
import store from '@/store';
import { ActionsKeys, RootGettersReturns } from '@/store/types';

export const baseURL = `${process.env.VUE_APP_API_URL}`;

const API = axios.create({
  baseURL,
});

// Add a 401 response interceptor
axios.interceptors.response.use(
  response => response,
  error => {
    if (401 === error.response.status) {
      if ((store.getters as RootGettersReturns).isLoggedIn) {
        store.dispatch(ActionsKeys.LOGOUT);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export const APInotLoggedIn = axios.create({
  baseURL,
});

export default API;
